import { useState, useEffect } from "react";
import { client } from "@/utils/sanity";

export const usePartners = () => {
  const [partners, setPartners] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const query = `*[_type == "partners"] | order(id)`;
        const partnersData = await client.fetch(query);
        setPartners(partnersData);
      } catch (error) {
        console.error("Error fetching partners:", error);
      }
    };

    fetchData();
  }, []);

  return partners;
};